import React, { Suspense, useEffect, memo, useMemo } from "react";
import config from "./moduleMap";
import loadable from "@loadable/component";
import { ErrorBoundary } from "react-error-boundary";
import logger from "./logger";
import Modules from "./modules";
import ModuleLoader from "./components/ModuleLoader";
const loadableCache = {};
function getLoadableComponent(moduleMap) {
    if (!loadableCache[moduleMap]) {
        loadableCache[moduleMap] = loadable(() => import(`./modules/${moduleMap}`), { ssr: true });
    }
    return loadableCache[moduleMap];
}
function WrapperModule(props) {
    let { siteConfig, pagedata, moduleCount, browserDetails, pathName } = props;
    useEffect(() => {
        import("./helpers").then(({ handleUserLogInState }) => {
            handleUserLogInState();
        });
    }, [pagedata]);
    const WatchNewModules = memo(function _WatchModules() {
        return moduleCount > 4 ? (React.createElement(Modules, { siteConfig: siteConfig, pagedata: pagedata, offset: 4, moduleCount: moduleCount })) : null;
    }, (prevProps, nextProps) => prevProps["pathName"] === nextProps["pathName"]);
    const modules = useMemo(() => {
        return pagedata === null || pagedata === void 0 ? void 0 : pagedata.map((module, index) => {
            var _a;
            const moduleMap = ((_a = module === null || module === void 0 ? void 0 : module.layout) === null || _a === void 0 ? void 0 : _a.view) ? config.map[module.layout.view] : null;
            if (!moduleMap) {
                return logger(`Module not found for '${moduleMap}'`, "warn");
            }
            const Component = getLoadableComponent(moduleMap);
            return (React.createElement("div", { key: module.id },
                React.createElement(ErrorBoundary, { fallback: React.createElement("p", null, "Something went wrong") },
                    React.createElement(Suspense, { fallback: null },
                        React.createElement(Component, { browserDetails: browserDetails, siteConfig: siteConfig, moduleData: module, isFirstModule: index === 0 })))));
        });
    }, [pagedata, browserDetails, siteConfig]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ModuleLoader, null),
        modules,
        React.createElement(WatchNewModules, { ...props })));
}
export default memo(WrapperModule, (prevProps, nextProps) => {
    return prevProps.pagedata === nextProps.pagedata;
});
